import PostTable from '@/components/post-table/PostTable'
import { TableLink } from '@/components/table-archive/TableComponents'

import { decodeSafeEntities } from '@/lib/sanitise-strings'

import type { WP_Term_Object } from '@/types/wp'
import type { WP_API_PostObjectResponse } from '@/types/wp-api'

type Opportunity = WP_API_PostObjectResponse[] | WP_Term_Object[]

type OpportunitiesTableProps = {
  columns: string[]
  columnsToHide?: string[]
  opportunities: Opportunity
}

export default function OpportunitiesTable({
  columns,
  columnsToHide,
  opportunities,
}: OpportunitiesTableProps): JSX.Element {
  const items = {
    columns,
    rows: opportunities?.length
      ? opportunities?.map((opportunity) => {
          const businessName =
            opportunity?.opportunity?.custom_organisation?.title ||
            opportunity?.business_info.name ||
            ''

          const businessUrl =
            opportunity?.opportunity?.custom_organisation?.url ||
            opportunity?.business_info.url ||
            ''

          const typesArr = opportunity?.types_taxonomy as WP_Term_Object[]
          const sectorsArr = opportunity?.sectors_taxonomy as WP_Term_Object[]
          const types = typesArr?.length
            ? typesArr.map((tax) => decodeSafeEntities(tax.name)).join(', ')
            : ''
          const sectors = sectorsArr?.length
            ? sectorsArr?.map((tax) => decodeSafeEntities(tax.name)).join(', ')
            : ''

          const closingDate = opportunity?.closing_date ?? '---'

          return [
            <TableLink
              key={'title' + opportunity.ID}
              title={opportunity.post_title}
              link={opportunity.permalink}
            />,

            !types || columnsToHide?.includes('Types') ? null : <>{types}</>,

            !sectors || columnsToHide?.includes('Sectors') ? null : <>{sectors}</>,

            columnsToHide?.includes('Organisation') ? null : (
              <TableLink key={'org' + opportunity.ID} title={businessName} link={businessUrl} />
            ),

            columnsToHide?.includes('Closing Date') ? null : <>{closingDate}</>,
          ]
        })
      : [],
  }

  return <PostTable items={items} />
}
